module.exports = __webpack_public_path__ + "img/tmp.cda9f8ee.png";